import {useQuery} from '@tanstack/react-query';
import {getCompaniesLatestStories} from '../operations/get-companies-latest-stories';
import {usePressReleaseQuery} from './use-press-release-query';

/**
 * プレスリリースページで本文下に表示する、配信企業の新着ストーリを取得するクエリ
 */
export const useLatestStoriesQuery = () => {
  const {data: pressRelease} = usePressReleaseQuery();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['latestStories', pressRelease?.companyId],
    async queryFn() {
      if (pressRelease === undefined) {
        return [];
      }

      // 配信企業の最新のストーリーを20件取得
      const {data: stories} = await getCompaniesLatestStories(
        pressRelease.companyId,
        20,
      );

      // undefined の時、空の配列を返す
      return stories ?? [];
    },
  });

  return query;
};
